<template>
  <div>
    <span></span>
    <Modal
        title="价格编辑"
        v-model="Modallist.ModalShow"
        v-if="Modallist.ModalShow"
        :loading="Modallist.isloading"
        @on-ok="SubmitHandleClick"
        :closable="false">
        <Form :model="Modallist.info" label-position="top">
            <FormItem v-if="err">
               <span>{{ err }}</span>
           </FormItem>
           <FormItem :label="item.AttributesName" v-for="item of Modallist.info.datalist" :key="item.AttributesID">
               <Select  filterable :label-in-value="true" clearable :v-model="item.AttributesName"
                        @on-change="SelectHandle"
                        @on-open-change="SelectionOpenHandle(item.AttributesID)"
                        @on-clear="ClearHandleClick(item.AttributesID)"
                        >
                <Option v-for="item1 in item.PriceModalValue" :value="item1.Attributes_value_ID" :key="item1.Attributes_value_ID">{{ item1.Name }}</Option>
               </Select>
           </FormItem>
           <FormItem label="价格">
               <Input v-model="Modallist.info.price" clearable type="number"></Input>
           </FormItem>
        </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'PriceModal',
  props: {
    Modallist: {
      ModalShow: false,
      isloading: true,
      info: {
        price: 0,
        datalist: []
      }
    }
  },
  data () {
    return {
      info: {
        price: 0,
        datalist: []
      },
      AttributesID: '', // 当前下拉的AttributesID
      err: ''
    }
  },
  methods: {
    SelectHandle (result) {
      const d = {
        AttributesID: this.AttributesID,
        value: result.value,
        label: result.label
      }
      let check = true
      for (let i = 0; i < this.info.length; ++i) {
        if (this.info.datalist[i].AttributesID === d.AttributesID) {
          check = false
          this.info.datalist[i].value = d.value
          this.info.datalist[i].label = d.label
          break
        }
      }
      if (check) {
        this.info.datalist.push(d)
      }
    },
    // 下拉打开的时候触发的事件
    SelectionOpenHandle (AttributesID) {
      this.AttributesID = AttributesID
    },
    // 清空下拉的时候触发
    ClearHandleClick (AttributesID) {
      for (let i = 0; i < this.info.datalist.length; ++i) {
        if (this.info.datalist[i].AttributesID === AttributesID) {
          this.info.datalist.splice(i, 1)
          break
        }
      }
    },
    // 点击确认按钮事件回调
    SubmitHandleClick () {
      let valid = true
      let err = ''
      if (this.info.datalist.length !== this.Modallist.info.datalist.length) {
        valid = false
        err = '有属性未选择,请确认'
      }
      if (this.Modallist.info.price === 0) {
        valid = false
        err = err + '  请填写价格'
      }
      if (valid) {
        this.err = ''
        this.info.price = this.Modallist.info.price
        const info = this.info
        this.info = {
          price: 0,
          datalist: []
        }
        this.$emit('SubmitHandleClick', info, false)
      } else {
        this.$emit('SubmitHandleClick', this.info, true)
        this.err = err
      }
    }
  }
}
</script>
